<template>
  <section class="ic-winwheel">
    <div class="title_cover" style="margin-bottom: 35px">
      <h3>{{ data.spin_n_win.text || "" }}</h3>
    </div>
    <div class="mobile-container">
      <div class="wheel-wrapper">
        <div class="canvas-wrapper">
          <canvas
            id="canvas"
            width="310"
            height="310"
            data-responsiveMinWidth="180"
            data-responsiveScaleHeight="true"
            data-responsiveMargin="50"
          >
            <p
              style="
                 {
                  color: white;
                }
              "
              align="center"
            >
              Sorry, your browser doesn't support canvas. Please try Google
              Chrome.
            </p>
          </canvas>
        </div>
        <div class="text-center button_motif mt-4 mb-4 button-wrapper">
          <v-btn
            large
            rounded
            color="primary"
            dark
            @click="startSpin"
            :disabled="disabledSpin"
            style="width: 100%"
          >
            SPIN
          </v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import * as Winwheel from "./Winwheel";
/* eslint-enable */
export default {
  name: "SpinWin",
  props: ["data"],
  data() {
    return {
      loadingPrize: false,
      sending: false,
      theWheel: null,
      wheelPower: 1,
      wheelSpinning: false,
      stop: true,
      disabledSpin: false,
      WinWheelOptions: {
        textFontSize: 14,
        outterRadius: 410,
        innerRadius: 25,
        lineWidth: 8,
        //drawText: true,
        //drawMode: "image",
        responsive: true,
        animation: {
          type: "spinOngoing",
          duration: 0.5,
        },
      },
      segments: [],
    };
  },
  methods: {
    startSpin() {
      var th = this;
      if (this.wheelSpinning === false) 
      {
        this.theWheel.startAnimation();
        this.wheelSpinning = true;
        this.theWheel = new Winwheel.Winwheel({
          ...this.WinWheelOptions,
          numSegments: this.segments.length,
          segments: this.segments,
          animation: {
            type: "spinToStop",
            duration: 8,
            spins: 8,
            callbackFinished: this.onFinishSpin,
          },
        });

        if (this.data.spin_n_win.type == "photo") 
        {
          // Create new image object in memory.
          let loadedImg = new Image();

          let th = this;
          // Create callback to execute once the image has finished loading.
          loadedImg.onload = function () {
            th.theWheel.wheelImage = loadedImg; // Make wheelImage equal the loaded image object.
            th.theWheel.draw(); // Also call draw function to render the wheel.
          };

          // Set the image source, once complete this will trigger the onLoad callback (above).
          loadedImg.src = this.data.spin_n_win.other_image.real;
        }

        // example input prize number get from Backend
        // Important thing is to set the stopAngle of the animation before stating the spin.
        //var prizeNumber = Math.floor(Math.random() * this.segments.length); // or just get from Backend

        //var stopAt = 360 / this.segments.length * prizeNumber - 360 / this.segments.length / 2 // center pin
        /*var stopAt =
          (360 / this.segments.length) * prizeNumber -
          Math.floor(Math.random() * 60); //random location*/
        //var stopAt = prizeNumber + 180

        this.$store.dispatch('api_post_ic_spinwin', function(res){
          if( res && res.segment )
          {
            var stopAt = th.theWheel.getRandomForSegment(res.segment);

            th.theWheel.animation.stopAngle = stopAt;
            th.theWheel.startAnimation();
            th.wheelSpinning = false;
            th.disabledSpin = true;
          }
        });
      }
    },
    resetWheel() {
      this.theWheel = new Winwheel.Winwheel({
        ...this.WinWheelOptions,
        numSegments: this.segments.length,
        segments: this.segments,
      });
      if (this.wheelSpinning) {
        this.theWheel.stopAnimation(false); // Stop the animation, false as param so does not call callback function.
      }
      this.theWheel.rotationAngle = 0; // Re-set the wheel angle to 0 degrees.
      this.theWheel.draw(); // Call draw to render changes to the wheel.
      this.wheelSpinning = false; // Reset to false to power buttons and spin can be clicked again.
    },
    initSpin() {
      this.loadingPrize = true;
      this.resetWheel();
      this.loadingPrize = false;
    },
    onFinishSpin(indicatedSegment) {
      this.$store.state.data.post.answer[indicatedSegment.qs] =
        indicatedSegment.id;
      this.$store.state.data.post.is_finished = 1;
      this.$forceUpdate();
      this.stop = true;
      if (!this.sending) this.next();
      this.sending = true;
    },
    next() {
      var th = this;

      if (th.stop) {
        th.stop = false;

        setTimeout(function () {
          //Send Tracker
          th.sendtoCDP();
          th.sendExternalTracker();

          th.$parent.submit();

          //re validate answer
          th.$store.commit("set_isvalid_answer", true);
        }, 1500);
      }
    },
  },
  computed: {},
  updated() {},
  mounted() {
    //init data
    if (this.data.spin_n_win.option) {
      this.segments = [];

      for (var i in this.data.spin_n_win.option) {
        if (
          this.data.spin_n_win.type == "text" &&
          this.data.spin_n_win.option_type == "text"
        ) {
          // SPIN N WIN TEXT
          this.WinWheelOptions.drawText = true;

          this.segments.push({
            textFillStyle: i % 2 == 0 ? "#fff" : "#000",
            fillStyle: i % 2 == 0 ? "#000" : "#fff",
            qs: this.data.spin_n_win.id,
            id: this.data.spin_n_win.option[i].id,
            text: this.data.spin_n_win.option[i].text,
          });
        } else if (
          this.data.spin_n_win.type == "text" &&
          this.data.spin_n_win.option_type == "photo"
        ) {
          // SPIN N WIN IMAGE PER SEGMENT
          this.WinWheelOptions.drawText = false;
          this.WinWheelOptions.drawMode = "segmentImage";

          this.segments.push({
            image: this.data.spin_n_win.option[i].other_image.real,
            qs: this.data.spin_n_win.id,
            id: this.data.spin_n_win.option[i].id,
            //text: this.data.spin_n_win.option[i].text,
          });
        } else if (this.data.spin_n_win.type == "photo") {
          this.WinWheelOptions.drawText = false;
          this.WinWheelOptions.drawMode = "image";

          this.segments.push({
            textFillStyle: i % 2 == 0 ? "#fff" : "#000",
            fillStyle: i % 2 == 0 ? "#000" : "#fff",
            qs: this.data.spin_n_win.id,
            id: this.data.spin_n_win.option[i].id,
            text: this.data.spin_n_win.option[i].text,
          });

          // Create new image object in memory.
          let loadedImg = new Image();

          let th = this;
          // Create callback to execute once the image has finished loading.
          loadedImg.onload = function () {
            th.theWheel.wheelImage = loadedImg; // Make wheelImage equal the loaded image object.
            th.theWheel.draw(); // Also call draw function to render the wheel.
          };

          // Set the image source, once complete this will trigger the onLoad callback (above).
          loadedImg.src = this.data.spin_n_win.other_image.real;
        }
      }
    }
    this.sending = false;
    this.initSpin();
    // this.resetWheel()
  },
  created() {},
};
</script>

<style scoped>
.ic-winwheel {
  text-align: center;
  background-image: url("/static/img/obstacle-run/bg-spinner-mobile.svg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
}
.ic-winwheel h1 {
  color: #fff;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 36px;
  letter-spacing: 4px;
  margin: 0 0 10px;
}
.ic-winwheel h2 {
  margin: 0;
}
.ic-winwheel #modalSpinwheel.custom-modal .content-wrapper .content {
  width: calc(100vw - 30px);
  padding-top: 52px;
}
.ic-winwheel #modalSpinwheel.custom-modal .content-wrapper .content h2 {
  text-transform: uppercase;
  color: #b32656;
  margin-bottom: 16px;
  margin-top: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 18px;
  letter-spacing: 1.1px;
  margin: 0;
}
.ic-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: black;
  text-align: center;
  line-height: 25px;
}
.ic-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p strong {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.ic-winwheel
  #modalSpinwheel.custom-modal
  .content-wrapper
  .content
  .modal-dismiss {
  top: 12px;
  right: 12px;
}
.ic-winwheel
  #modalSpinwheel.custom-modal
  .content-wrapper
  .content
  .modal-dismiss
  i.icon_close {
  font-size: 30px;
  color: #da2a52;
}
.ic-winwheel canvas#canvas {
  position: relative;
  max-width: 100%;
}
.ic-winwheel .canvas-wrapper {
  position: relative;
}
.ic-winwheel .canvas-wrapper:after {
  content: "";
  display: block;
  width: 42px;
  background: #c4376f;
  height: 42px;
  position: absolute;
  left: calc(50% - 25px);
  margin: auto;
  border-radius: 100%;
  top: calc(50% - 29px);
  border: 5px solid white;
  box-sizing: content-box;
}
.ic-winwheel .canvas-wrapper:before {
  content: "";
  display: block;
  width: 310px;
  background: #0f0f0f;
  height: 310px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 100%;
  top: 0;
  max-width: 100%;
  max-height: 100%;
}
.ic-winwheel .wheel-wrapper {
  position: relative;
}
.ic-winwheel .wheel-wrapper:before {
  content: "";
  width: 62px;
  height: 47px;
  position: absolute;
  top: -10px;
  left: calc(50% - 31px);
  right: 0;
  display: block;
  z-index: 99999;
  background-image: url("./spinner-marker.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.ic-winwheel .wheel-wrapper .button-wrapper {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 231px;
  height: 118px;
}
.ic-winwheel .wheel-wrapper .btn.btn-play {
  padding: 0 58px !important;
  background: #c4376f;
  height: 40px;
  line-height: 40px;
  color: white;
  font-weight: bold;
  text-decoration: none;
  border-radius: 2px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  letter-spacing: 2px;
}
</style>
